import React from 'react';
import { useFormikContext } from 'formik';
import styled from 'styled-components';

import * as api from '~/myApi'

import { Button } from '@mui/material';

import TextField from '~/component/form/TextField'
import Switch from '~/component/form/Switch'

import CloseIcon from '@mui/icons-material/Close';

import { FieldArray } from 'formik';

const AnswerContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  > * {
    white-space: nowrap;
  }
`;
const AnswerTextField = styled(TextField)`
  margin-right: 16px;
  flex-grow: 1;
`;

const AddButtonContainer = styled.div`
  display: flex;
`;

interface FormFieldProps {
  value?: api.TypesAnswer[];
  index: number
  hasFixOrderSwitch?: boolean
  hasExclusiveSwitch?: boolean
}

const MAX_ANSWER_NUM = 5

export const Answers = <T extends {}>(props: FormFieldProps) => {
  const { setFieldValue } = useFormikContext<T>()
  const answersName = `questions[${props.index}].answers`

  const changeOrder = (value = props.value) => {
    const answersValue = value?.map((answer, i) => {
      return Object.assign({}, answer, { order: i })
    })

    setFieldValue(answersName, answersValue)
  }

  const removeAnswer = (index: number) => {
    const answersValue = props.value!.filter((value, i) => i !== index)

    changeOrder(answersValue)
  }

  const addAnswer = () => {
    const answersValue = props.value!.concat({
      text: '',
      fixOrder: false,
      exclusive: false,
    })

    changeOrder(answersValue)
  }
  
  return (
    <FieldArray
      name={answersName}
      render={(arrayHelpers) => {
        return (
          <div>
            {props.value?.map((answer, i) => {
              const answerName = `${answersName}[${i}]`
              return (
                <AnswerContainer key={i}>
                  <AnswerTextField {...{
                    name: `${answerName}.text`,
                    type: 'string',
                    value: answer.text
                  }} />
                  {props.hasFixOrderSwitch && (
                    <Switch {...{
                      label: '固定',
                      name: `${answerName}.fixOrder`,
                      value: answer?.fixOrder,
                    }} />
                  )}
                  {props.hasExclusiveSwitch && (
                    <Switch {...{
                      label: '排他',
                      name: `${answerName}.exclusive`,
                      value: answer?.exclusive,
                    }} />
                  )}
                  <Switch {...{
                    label: 'ポジ',
                    name: `${answerName}.lift`,
                    value: answer?.lift,
                    trueValue: '1',
                    falseValue: '0',
                  }} />

                  {(props.value?.length! > 2) && (
                    <Button
                      variant="outlined"
                      color="error"
                      startIcon={<CloseIcon />} 
                      onClick={() => {
                        removeAnswer(i)
                      }}
                    >
                      削除
                    </Button>
                  )}
                </AnswerContainer>
              )
            })}

            {props.value?.length! < MAX_ANSWER_NUM && (
              <AddButtonContainer>
                <Button variant="outlined" onClick={(e) => {
                  addAnswer()
                }}>
                  + 回答の選択肢を追加
                </Button>
              </AddButtonContainer>
            )}

          </div>
        )
      }}
    />
  )
}

export default Answers